export default "__VITE_ASSET__eNhQwy52__"